module.exports = __webpack_public_path__ + "static/media/bg-login-dashboard-min.74c55771.jpg";